import React from "react";

import queryString from "query-string";
import {decode as base64_decode, encode as base64_encode} from "base-64";
import {ReactSession} from "react-client-session";
import {Helpers} from "../../config/Helpers";
import $ from "jquery";
import {toast} from "react-toastify";

class Payment extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            sessKodeNasabah: (ReactSession.get("sess_kodenasabah")) ? ReactSession.get("sess_kodenasabah") : '',
            summaryData: '',
            paymentData: [],
            orderData: [],
            orderTotal: 0,
            orderGrandTotal: 0,
            orderKomisiDigunakan: 0,
            orderBBXTabunganDigunakan: 0,
            orderBBXPoinDigunakan: 0,
            orderPaymentObj: '',
            orderPaymentMethod: '',
            orderPaymentMethodType: '',
            orderPaymentCharge: 0,
            orderPaymentFee: '',
            orderType: (ReactSession.get("order_type")) ? ReactSession.get("order_type") : 'Grosir',
            branchCode: (ReactSession.get("branch_code")) ? ReactSession.get("branch_code") : 'CBNG-18-020001',
            isCommissionChecked: false,
            saldoCommission: 0,
            typeCommission: 'Pilih',
            isBBXTabunganChecked: false,
            saldoBBXTabungan: 0,
            isBBXPoinChecked: false,
            saldoBBXPoin: 0,
            urlParam: queryString.parse(window.location.search),
            koinWorksTenor: '30',
            id_store_bbx: '',
            password_waroq: '',
            ppobNomor: ReactSession.get("ppob_nomor") || "",
            ppobProvider: ReactSession.get("ppob_provider") || "",
            ppobProduk: ReactSession.get("ppob_produk") || "",
            ppobKode: ReactSession.get("ppob_kode") || "",
            ppobPrice: ReactSession.get("ppob_price") || "",
            ppobType: ReactSession.get("ppob_type") || "",
            isLimitChecked: false
        }
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.getSummary();
        }
    }

    getSummary = () => {
        Helpers.getSummary(this.state.sessUserCode, this.state.sessKodeNasabah).then(res => {
            this.setState({
                summaryData: res[0],
                saldoCommission: res[0].commission_now_raw,
                saldoBBXTabungan: res[0].bbx_tabungan,
                saldoBBXPoin: res[0].bbx_poin,
                id_store_bbx: res[0].id_store_bbx,
                orderGrandTotal: this.state.ppobPrice,
                orderTotal: this.state.ppobPrice
            }, () => {
                 this.callPaymentMethod();
            });
        })
    };

    callPaymentMethod = () => {
        Helpers.getListPaymentChannel(
            '',
            parseInt(this.state.orderGrandTotal)
        ).then(res => {
            const generatePaymentMethod = res
                .filter(object => object.KodePaymentGateway !== "Limit")
                .map((object, i) => {
                return <tr>
                    <td>
                        <input type="radio" disabled={this.state.isLimitChecked} style={{'height': '11px', width: '11px'}} value={object.KodePaymentGateway} name="paymentmethod" checked={((this.state.orderPaymentMethod == object.KodePaymentGateway) ? 'checked' : '')} onChange={() => {this.handleRadioPaymentChange(object)}}/>
                    </td>
                    <td className="image product-thumbnail"><img
                        src={object.Logo} alt="#"/></td>
                    <td>
                        <h6 className="text-brand text-align-left" style={{'vertical-align': 'unset'}}>{object.Shortname}</h6>
                        <h6 className="w-160 mb-5 text-align-left">
                            {
                                object.KodePaymentGateway == 'Limit' && (
                                    <a href="#" className="text-heading">Saldo: Rp {this.state.summaryData.credit_limit}</a>
                                )
                            }
                            {
                                object.KodePaymentGateway == 'Saldo' && (
                                    <a href="#" className="text-heading">Saldo: Rp {this.state.summaryData.saldo_waroq}</a>
                                )
                            }
                            {
                                object.KodePaymentGateway == 'KPG-0017' && (
                                    <a href="#" className="text-heading">Saldo: Rp {this.state.summaryData.KoinWorksLimitFormat}</a>
                                )
                            }
                            {
                                (object.KodePaymentGateway !== 'Limit' && object.KodePaymentGateway !== 'Saldo' && object.KodePaymentGateway !== 'KPG-0017') && (
                                    <a href="#" className="text-heading">{object.Fullname}</a>
                                )
                            }
                        </h6>
                    </td>
                </tr>
            });

            this.setState({
                paymentData: res,
                generatePaymentMethod
            });
        })
    };


    calculateTotal = () => {
        let jasa_kirim = 0;
        let total_harga_kj = parseInt(this.state.orderTotal) + jasa_kirim;
        let poinwaroq = parseInt(this.state.summaryData.commission_now_raw);
        let pointabungan = (parseInt(this.state.summaryData.bbx_tabungan) > 100000) ? parseInt(this.state.summaryData.bbx_tabungan)-100000 : 0;
        let poinbbx = parseInt(this.state.summaryData.bbx_poin);
        let payment = this.state.orderPaymentMethod;
        let paymenttype = this.state.orderPaymentMethodType;
        let paymentcharge = parseInt(this.state.orderPaymentCharge);
        if(this.state.isLimitChecked){
            payment = "Limit";
            paymenttype = "Limit";
            paymentcharge = 0;
        }
        let poinwaroqused = 0;
        let pointabunganused = 0;
        let poinbbxused = 0;
        let poinwaroqleft = poinwaroq;
        let pointabunganleft = pointabungan;
        let poinbbxleft = poinbbx;
        let jeniskomisi = '';

        if(this.state.orderPaymentObj){
            payment = this.state.orderPaymentObj.KodePaymentGateway;
            paymenttype = this.state.orderPaymentObj.JenisBank;
            paymentcharge = this.state.orderPaymentObj.FeeTotal;
        }

        console.log(this.state.orderPaymentObj);

        if(this.state.isCommissionChecked && this.state.isBBXTabunganChecked && this.state.isBBXPoinChecked){
            jeniskomisi = "Potongan";

            if(poinwaroq >= total_harga_kj){
                payment = 'Saldo';
                poinwaroqused = total_harga_kj;
                poinwaroqleft = poinwaroq-total_harga_kj;

                this.setState({ isBBXTabunganChecked: false, isBBXPoinChecked: false });
            }else{
                poinwaroqused = poinwaroq;
                poinwaroqleft = 0;

                let sisaafterwaroq = total_harga_kj-poinwaroqused;

                if(pointabungan >= sisaafterwaroq){
                    payment = 'Saldo';
                    pointabunganused = sisaafterwaroq;
                    pointabunganleft = pointabungan-sisaafterwaroq;

                    this.setState({ isBBXPoinChecked: false });
                }else{
                    pointabunganused = pointabungan;
                    pointabunganleft = 0;

                    let sisaaftertabungan = sisaafterwaroq-pointabunganused;

                    if(poinbbx >= sisaaftertabungan){
                        payment = 'Saldo';
                        poinbbxused = sisaaftertabungan;
                        poinbbxleft = poinbbx-sisaaftertabungan;
                    }else{
                        poinbbxused = poinbbx;
                        poinbbxleft = 0;
                    }
                }
            }
        }else if(this.state.isCommissionChecked && this.state.isBBXTabunganChecked && !this.state.isBBXPoinChecked){
            jeniskomisi = "Potongan";

            if(poinwaroq >= total_harga_kj){
                payment = 'Saldo';
                poinwaroqused = total_harga_kj;
                poinwaroqleft = poinwaroq-total_harga_kj;

                this.setState({ isBBXTabunganChecked: false });
            }else{
                poinwaroqused = poinwaroq;
                poinwaroqleft = 0;

                let sisaafterwaroq = total_harga_kj-poinwaroqused;

                if(pointabungan >= sisaafterwaroq){
                    payment = 'Saldo';
                    pointabunganused = sisaafterwaroq;
                    pointabunganleft = pointabungan-sisaafterwaroq;
                }else{
                    pointabunganused = pointabungan;
                    pointabunganleft = 0;
                }
            }
        }else if(this.state.isCommissionChecked && !this.state.isBBXTabunganChecked && this.state.isBBXPoinChecked){
            jeniskomisi = "Potongan";

            if(poinwaroq >= total_harga_kj){
                payment = 'Saldo';
                poinwaroqused = total_harga_kj;
                poinwaroqleft = poinwaroq-total_harga_kj;

                this.setState({ isBBXTabunganChecked: false });
            }else{
                poinwaroqused = poinwaroq;
                poinwaroqleft = 0;

                let sisaafterwaroq = total_harga_kj-poinwaroqused;

                if(poinbbx >= sisaafterwaroq){
                    payment = 'Saldo';
                    poinbbxused = sisaafterwaroq;
                    poinbbxleft = poinbbx-sisaafterwaroq;
                }else{
                    poinbbxused = poinbbx;
                    poinbbxleft = 0;
                }
            }
        }else if(this.state.isCommissionChecked && !this.state.isBBXTabunganChecked && !this.state.isBBXPoinChecked){
            jeniskomisi = "Potongan";

            if(poinwaroq >= total_harga_kj){
                payment = 'Saldo';
                poinwaroqused = total_harga_kj;
                poinwaroqleft = poinwaroq-total_harga_kj;
            }else{
                poinwaroqused = poinwaroq;
                poinwaroqleft = 0;
            }
        }else if(!this.state.isCommissionChecked && this.state.isBBXTabunganChecked && this.state.isBBXPoinChecked){
            if(pointabungan >= total_harga_kj){
                payment = 'Saldo';
                pointabunganused = total_harga_kj;
                pointabunganleft = pointabungan-total_harga_kj;

                this.setState({ isBBXPoinChecked: false });
            }else{
                pointabunganused = pointabungan;
                pointabunganleft = 0;

                let sisaaftertabungan = total_harga_kj-pointabunganused;

                if(poinbbx >= sisaaftertabungan){
                    payment = 'Saldo';
                    poinbbxused = sisaaftertabungan;
                    poinbbxleft = poinbbx-sisaaftertabungan;
                }else{
                    poinbbxused = poinbbx;
                    poinbbxleft = 0;
                }
            }
        }else if(!this.state.isCommissionChecked && this.state.isBBXTabunganChecked && !this.state.isBBXPoinChecked){
            jeniskomisi = "Potongan";

            if(pointabungan >= total_harga_kj){
                payment = 'Saldo';
                pointabunganused = total_harga_kj;
                pointabunganleft = pointabungan-total_harga_kj;
            }else{
                pointabunganused = pointabungan;
                pointabunganleft = 0;
            }
        }else if(!this.state.isCommissionChecked && !this.state.isBBXTabunganChecked && this.state.isBBXPoinChecked){
            jeniskomisi = "Potongan";

            if(poinbbx >= total_harga_kj){
                payment = 'Saldo';
                poinbbxused = total_harga_kj;
                poinbbxleft = poinbbx-total_harga_kj;
            }else{
                poinbbxused = poinbbx;
                poinbbxleft = 0;
            }
        }

        if(payment === 'Saldo'){
            paymenttype = 'Saldo';
            paymentcharge = 0;
        }

        let total_harga_by_flow = total_harga_kj + paymentcharge - poinwaroqused - pointabunganused - poinbbxused;

        this.setState({
            typeCommission: jeniskomisi,
            orderPaymentMethodType: paymenttype,
            orderPaymentMethod: payment,
            orderGrandTotal: total_harga_by_flow,
            orderPaymentCharge: paymentcharge,
            orderKomisiDigunakan: poinwaroqused,
            saldoCommission: poinwaroqleft,
            orderBBXPoinDigunakan: poinbbxused,
            saldoBBXPoin: poinbbxleft,
            orderBBXTabunganDigunakan: pointabunganused,
            saldoBBXTabungan: pointabunganleft + ((parseInt(this.state.summaryData.bbx_tabungan) > 100000) ? 100000 : 0)
        }, () => {
            this.callPaymentMethod();
        });
    };

    handleRadioPaymentChange = (object) => {
        this.setState({
            orderPaymentObj: object,
            orderPaymentMethod: object.KodePaymentGateway,
            orderPaymentFee: object.FeeTotal,
            orderPaymentMethodType: object.JenisBank
        }, () => {
            this.callPaymentMethod();
            this.calculateTotal();
        });

        if(object.KodePaymentGateway === 'KPG-0017'){
            $("#koinworks-tenor").css("display", "");
        }else{
            $("#koinworks-tenor").css("display", "none");
        }
    };

    handleCommissionChecked = () => {
        this.setState({
            isCommissionChecked: !this.state.isCommissionChecked
        }, () => {
            this.calculateTotal();
        });
    };

    handleBBXPoinChecked = () => {
        this.setState({
            isBBXPoinChecked: !this.state.isBBXPoinChecked
        }, () => {
            this.calculateTotal();
        });
    };

    handleBBXTabunganChecked = () => {
        this.setState({
            isBBXTabunganChecked: !this.state.isBBXTabunganChecked
        }, () => {
            this.calculateTotal();
        });
    };

    handleUpload = () => {
        if(this.state.kodeMarketPlaceDetail !== ''){
            this.handleCheckPayment();
        }else{
            if(this.state.orderType == 'Grosir'){
                this.handleCheckPayment();
            }else if(this.state.orderType == 'Retail'){
                this.handleCheckPayment();
            }else{
                toast.error("Nominal belanja belum dipilih");
            }
        }
    };

    handleCheckPayment = () => {
        if(this.state.orderPaymentMethodType == 'Limit'){
            if(parseInt(this.state.orderGrandTotal) <= parseInt(this.state.summaryData.credit_limit_raw)){
                this.handleSendUpload();
            }else{
                toast.error("Total order di keranjang tidak boleh melebihi limit yang tersedia");
            }
        }else if(this.state.orderPaymentMethodType == 'Saldo'){
            if(parseInt(this.state.orderGrandTotal) <= parseInt(this.state.summaryData.saldo_waroq_raw)){
                this.handleSendUpload();
            }else{
                toast.error("Total order di keranjang tidak boleh melebihi saldo yang tersedia");
            }
        }else if(this.state.orderPaymentMethodType == 'Bank'){
            this.handleSendUpload();
        }else if(this.state.orderPaymentMethodType == 'e-Money'){
            this.handleSendUpload();
        }else if(this.state.orderPaymentMethodType == 'Credit Card'){
            this.handleSendUpload();
        }else if(this.state.orderPaymentMethodType == 'Fintech'){
            this.handleSendUpload();
        }else{
            toast.error("Metode pembayaran belum dipilih");
        }
    };

    handleSendUpload = () => {
        this.handlePrepareUpload();
    };

    handlePrepareUpload = () => {
        if(parseInt(this.state.orderTotal) > 0){
            if (window.confirm('Apakah order anda sudah sesuai? Klik ok untuk melanjutkan')) {
                if(this.state.isBBXTabunganChecked || this.state.isBBXPoinChecked){
                    if(ReactSession.get("sess_password") === this.state.password_waroq){
                        this.submitOrderSend();
                    }else{
                        toast.error("Password tidak sesuai");
                    }
                }else{
                    this.submitOrderSend();
                }
            }else{
                console.log('Cancel.');
            }
        }else{
            toast.error("Anda belum memiliki item di keranjang");
        }
    };

    submitOrderSend = () => {
        Helpers.CreatePPOB(
            this.state.sessUserCode,
            'waroq',
            this.state.orderKomisiDigunakan,
            this.state.orderPaymentMethodType,
            this.state.orderPaymentMethod,
            this.state.ppobType,
            this.state.ppobProvider,
            this.state.ppobKode,
            this.state.ppobNomor
        ).then(res => {
            if(res.length > 0){
                if(res[0].alert == 'success'){
                    setTimeout(function() {
                        window.location.href = './ppob-details?trxid=' + base64_encode(res[0].KodePPOBPayment);
                    }, 1000);
                }

                toast[res[0].alert](res[0].message);
            }else{
                toast.error(Helpers.MSG_ERROR);
            }
        })
    };

    render() {
        return (
            <>
                <main className="main">
                    <div className="page-header breadcrumb-wrap">
                        <div className="container">
                            <div className="breadcrumb">
                                <a href="./" rel="nofollow"><i className="fi-rs-home mr-5"></i>Beranda</a>
                                <span></span> Pembayaran
                            </div>
                        </div>
                    </div>
                    <div className="container mb-80 mt-15">
                        <div className="row">
                            <div className="col-lg-4 m-auto">
                                <div className="border p-md-4 cart-totals ml-30 mb-15">
                                    <div className="table-responsive">
                                        <table className="table no-border" style={{'margin-bottom': '0px'}}>
                                            <tbody>
                                            <tr>
                                                <td className="cart_total_label" colSpan={3}>
                                                    <div className="container-title">
                                                        <div className="title-badge"></div>
                                                        <h6 className="text-muted m-0">Detail Transaksi</h6>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr align="left">
                                                <td className="image product-thumbnail">
                                                    <div className="iconx"></div>
                                                </td>
                                                <td>
                                                    <small className="text-muted">Nomor HP</small>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.ppobNomor}
                                                    </h6>
                                                </td>
                                            </tr>

                                            <tr align="left">
                                                <td className="image product-thumbnail">
                                                    <div className="icon1"></div>
                                                </td>
                                                <td>
                                                    <small className="text-muted">Provider</small>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.ppobProvider}
                                                    </h6>
                                                </td>
                                            </tr>

                                            <tr align="left">
                                                <td className="image product-thumbnail">
                                                    <div className="icon2"></div>
                                                </td>
                                                <td>
                                                    <small className="text-muted">Produk</small>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.ppobProduk}
                                                    </h6>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="border p-md-4 cart-totals ml-30 mb-15">
                                    <div className="table-responsive">
                                        <table className="table no-border">
                                            <tbody>
                                            <tr>
                                                <td className="cart_total_label" colSpan={3}>
                                                    <div className="container-title">
                                                        <div className="title-badge"></div>
                                                        <h6 className="text-muted m-0">Metode Pembayaran</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                            {
                                                this.state.generatePaymentMethod
                                            }
                                            <tr id="koinworks-tenor" style={{'display': 'none'}}>
                                                <td scope="col" colSpan={3}>
                                                    <div className="input-style">
                                                        <label>Pilih Tenor</label>
                                                        <div className="custom_select">
                                                            <select
                                                                className="select-style" onChange={e => this.setState({koinWorksTenor: e.target.value})}>
                                                                {
                                                                    Helpers.arrKoinWorksTenor.map((object, i) => {
                                                                        return <option value={object.value}>{object.label}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="border p-md-4 cart-totals ml-30">
                                    <div className="table-responsive">
                                        <table className="table no-border">
                                            <tbody>
                                            <tr>
                                                <td className="cart_total_label" colSpan={3}>
                                                    <div className="container-title">
                                                        <div className="title-badge"></div>
                                                        <h6 className="text-muted m-0"> Gunakan Saldo Lainnya</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="cart_total_label">
                                                    <h6 className="text-muted text-align-left">Gunakan Waroq Poin</h6>
                                                </td>
                                                <td className="cart_total_amount" align="right">
                                                    <input className="form-check-input" type="checkbox"
                                                           checked={this.state.isCommissionChecked}
                                                           onClick={() => {this.handleCommissionChecked()}}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="cart_total_label text-align-left">
                                                    <h6 style={{'color': '#253D4E'}}>Saldo: {parseInt(this.state.saldoCommission).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</h6>
                                                </td>
                                                <td className="cart_total_amount">
                                                    <h4 className="text-brand text-end">{parseFloat(this.state.orderKomisiDigunakan).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</h4>
                                                </td>
                                            </tr>
                                            <tr>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="border p-md-4 cart-totals ml-30">
                                    <div className="table-responsive">
                                        <table className="table no-border">
                                            <tbody>
                                            <tr>
                                                <td className="cart_total_label" colSpan={3}>
                                                    <div className="container-title">
                                                        <div className="title-badge"></div>
                                                        <h6 className="text-muted m-0"> Ringkasan Pembayaran</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="cart_total_label">
                                                    <h6 className="text-muted text-align-left">Harga Produk</h6>
                                                </td>
                                                <td className="cart_total_amount">
                                                    <h4 className="text-brand text-end">Rp {parseInt(this.state.ppobPrice).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</h4>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="cart_total_label">
                                                    <h6 className="text-muted text-align-left">Biaya Layanan</h6>
                                                </td>
                                                <td className="cart_total_amount">
                                                    <h5 className="text-brand text-end">{parseInt(this.state.orderPaymentCharge).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</h5></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2">
                                                    <div className="divider-2 mt-10 mb-20"></div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td colSpan="2">
                                                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                        <div>
                                                            <small className="text-muted">Total Pembayaran</small>
                                                            <h4 className="text-brand mb-0">
                                                                Rp{" "}
                                                                {parseInt(this.state.orderGrandTotal)
                                                                    .toLocaleString("id-ID")}
                                                            </h4>
                                                        </div>

                                                        <button
                                                            type="button"
                                                            className="btn btn-heading hover-up"
                                                            name="bayar"
                                                            onClick={() => this.handleSendUpload()}
                                                        >
                                                            Bayar
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        );
    }
}

export default Payment;